import {type IAsset} from '@netx/core-asset-next/schema';
import {type IConstituentClip} from '../schema';
import {canManageConstituentClip} from './canManageConstituentClip';

export const canDeleteConstituentClip = (
	asset?: IAsset,
	constituentClip?: IConstituentClip,
) => {
	return canManageConstituentClip(asset, constituentClip);
};
